export enum BoardToolbarAction {
  MakeFavorite = 'make_favorite',
  Download = 'download',
  Rename = 'rename',
  Copy = 'copy',
  Move = 'move',
  Delete = 'delete',
  RemoveFromBoard = 'remove_from_board',
  Open = 'open',
  Share = 'share',
  Duplicate = 'duplicate',
  CreateSubBoard = 'create_sub_board',
  AddToAnotherBoard = 'add_to_another_board',
  SaveAiAssistantGenerated = 'save_ai_assistant_generated',
  ResolveDuplicates = 'resolve_duplicates',
  AllowForAiAssistant = 'allow_for_ai_assistant',
}
  
export enum BoardAssetsToolbarAction {
  Open = 'open',
  // MakeFavorite = 'make_favorite',
  Download = 'download',
  Rename = 'rename',
  Move = 'move',
  Copy = 'copy',
  RemoveFromBoard = 'remove_from_board',
  Delete = 'delete',
  Share = 'share',
  AddToAnotherBoard = 'add_to_another_board',
  AllowForAiAssistant = 'allow_for_ai_assistant',
}